<template>
  <div style="height:100%;width:100%; display: flex;flex-direction: column;">
    <div style="height:50px;width:100%;background-color:#f8f8f8;">
      <div style="color:#970B0B;margin-top:15px;width:100%;height:50px" class="container_right">
        <div style="width:40%;display:flex">
          <div style="width:4px;background-color:#970B0B;height:40px"></div>
          <div style="margin:5px;color:#970B0B;">设备硬件配置</div>
        </div>
        <div style="width:50%;justify-content: center;display: flex;">
        </div>
        <div style="width:15%;color:#970B0B">
          <el-button @click="RightAddClick" size="mini"
            style="width:70%;background-color:#970B0B;color:#fff">新增设备硬件</el-button>
        </div>
      </div>
    </div>
    <div style="width:100%;height:100%">
      <el-table :data="groupIist" height="500px" size="medium" style="width: 100%;">
        <el-table-column fixed prop="id" label="项目ID" width="100">
        </el-table-column>
        <el-table-column prop="aid" label="aid" width="100">
        </el-table-column>
        <el-table-column prop="projectkey" label="projectkey" width="150">
        </el-table-column>
        <el-table-column prop="project" label="项目名称" width="150">
        </el-table-column>
        <el-table-column prop="hardwaretype" label="硬件设备名称" width="150">
        </el-table-column>
        <el-table-column prop="description" label="备注" width="200">
        </el-table-column>
        <el-table-column prop="createby" label="创建人" width="150">
        </el-table-column>
        <el-table-column prop="updateby" label="更新人" width="150">
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="200">
        </el-table-column>
        <el-table-column prop="updateTime" label="更新时间" width="200">
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="160">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

 <el-pagination
      style="text-align:center;margin:10px"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="1"
      :page-sizes="[10, 20, 30, 50]"
      :page-size="pageInfo.size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageInfo.total">
</el-pagination>

    <el-dialog :visible.sync="centerDialogVisible" width="80%" center :destroy-on-close=true :show-close=false
      :close-on-click-modal=false :close-on-press-escape=false>
      <div>
        <div style="height:40px;width:100%;background-color:#fff;">
          <div style="color:#970B0B;margin-top:15px;width:100%;height:40px" class="container_right">
            <div style="width:40%;display:flex">
              <div style="width:4px;background-color:#970B0B;height:40px"></div>
              <div style="margin:5px;color:#970B0B;">项目信息</div>
            </div>
            <div style="width:50%;justify-content: center;display: flex;"></div>
            <div style="width:15%;color:#970B0B"></div>
          </div>
        </div>
        <div style="height:60px;width:100%;background-color:#f8f8f8;">
          <div style="color:#970B0B;margin-top:20px;width:100%;height:60px" class="container_right">
            <div style="width:70%;display:flex">
              <div v-if="isGroupEdit" style="display: flex;margin:10px;">
                <div style="flex: 1;width:80px;margin-left:5px;margin-right:0px">ID：{{ groupInfo.id }}
                </div>
              </div>
              <div v-if="isGroupEdit" style="display: flex;margin:10px;">
                <div style="flex: 1;width:200px;margin-left:5px;margin-right:5px">projectkey：{{ groupInfo.projectkey }}
                </div>
              </div>


    <div style="display: flex;margin-left:0px;margin-top:10px;">
      <div style="flex: 1;width:200px;margin:5px;margin-right:0px">项目：</div>
        <el-select @change="selectChangeProject" size = "medium" placeholder="请选择项目" v-model="groupInfo.project" >

          <el-option
            v-for="item in ccprojectList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>

              <div style="display: flex;margin-left:10px;margin-top:10px;">
                <div style="flex: 1;width:80px;margin:5px;margin-right:5px">硬件设备：</div>
                <el-input style="width:200px;" placeholder="请输入硬件设备名称" v-model="groupInfo.hardwaretype" type="text"
                  clearable>
                </el-input>
              </div>
              <div style="display: flex;margin-left:10px;margin-top:10px;">
                <div style="flex: 1;width:80px;margin:5px;margin-right:5px">备注：</div>
                <el-input style="width:200px;" placeholder="备注" v-model="groupInfo.description" type="text" clearable>
                </el-input>
              </div>
            </div>
            <div style="width:50%;justify-content: center;display: flex;"></div>
            <div style="width:15%;color:#970B0B"></div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer ">
        <el-button style="width:120px" @click="centerDialogVisible = false">取 消</el-button>
        <el-button style="background-color:#970B0B;color:#fff;width:120px" @click="addGroup">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import TMApipath from 'TMApipath'
import { formatTime } from 'TMUtils'
import TMStore from 'TMStore'


export default {
  data() {
    return {
      aid: '',
      token:'',
      username:'',

      pageInfo: {
        val: 1,
        size: 10,
        total: 0
      },
      centerDialogVisible: false,
      isGroupEdit: true,
      groupInfo: {
        id: "",
        project: "",
        projectkey:'',
        createDate: "",
        createby: "",
        hardwaretype: "",
        updateby: "",

      },
      groupIist: [],
      ccprojectList:[]
    }
  },

  mounted() {
    var _this = this

      _this.token = TMStore.state.account.token
      _this.aid = TMStore.state.account.aid 
      _this.username = TMStore.state.account.username 
       _this.getConfigProjectListByPage(1,100);
      _this.getConfigHardwareTypeListByPage(_this.pageInfo.val, _this.pageInfo.size);
  },

  methods: {
      preclick(val){
            console.log(val)

      },
      handleSizeChange(val) {
        var _this =this;
        _this.pageInfo.size =  val;
        _this.getdownLogListByPage(_this.pageInfo.val,_this.pageInfo.size);
      },
        selectChangeProject(val){//匹配对应的VISON
        var _this = this

          for(var items in _this.ccprojectList){
                var item = _this.ccprojectList[items]


               if (item.value === val) {
                  _this.groupInfo.projectkey = item.value;
                  _this.groupInfo.project = item.label;

                  break;
               }

          }
      },
      getConfigProjectListByPage(pageIndex, pageSize){

          var _this = this 

          var reqdata = {pageIndex:pageIndex,pageSize:pageSize}
          var { urls} = _this.getresult(TMApipath.CONFIGMANAGE,TMApipath.URL_API_GETCONFIGPROJECTLISTBYPAGE, reqdata);


           let loadingInstance = _this.$loading({ fullscreen: true ,text:"Loading"});


          _this.axios.get(urls ).then((response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
            if (response.status ) {
              // vuex记录

                _this.ccprojectList =[];

                // _this.pageInfo.total = response.data.total

              for(var items in response.data.list){
                var item = response.data.list[items]

                var cutFeed ={
                  id: item.id,
                  project: item.project,
                  projectkey: item.projectkey,

                  value:item.projectkey,
                  label:item.project,

                }

                _this.ccprojectList.push(cutFeed);
              }


            }else{
              this.$message.error(response.msg);
            }
          }, (response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
            console.log(response)
          });


      },
    getConfigHardwareTypeListByPage(pageIndex, pageSize) {
      var _this = this
      var reqdata = { pageIndex: pageIndex, pageSize: pageSize }
      var { urls } = _this.getresult(TMApipath.CONFIGMANAGE, TMApipath.URL_API_GETCONFIGHARDWARETYPELISTBYPAGE, reqdata);
      let loadingInstance = _this.$loading({ fullscreen: true, text: "Loading" });
      _this.axios.get(urls).then((response) => {
        _this.$nextTick(() => { loadingInstance.close(); });
        if (response.status) {
          // vuex记录
          _this.groupIist = [];
          _this.pageInfo.total = response.data.total
          for (var items in response.data.list) {
            var item = response.data.list[items]
            var cutFeed = {
              id: item.id,
              aid: item.aid,
              project: item.project,
              projectkey: item.projectkey,
              hardwaretype: item.hardwaretype,
              description: item.description,
              createby: item.createby,
              updateby: item.updateby,
              createTime: formatTime(item.createDate),
              updateTime: item.updateDate!='' ? formatTime(item.updateDate) : '--'
            }
            _this.groupIist.push(cutFeed);
          }
        } else {
          this.$message.error(response.msg);
        }
      }, (response) => {
        _this.$nextTick(() => { loadingInstance.close(); });
        console.log(response)
      });
    },

    handleDelete(index, rows) {//待实现
      var _this = this;
      _this.$confirm('此操作将永久删除该控制按钮, 是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        _this.deleteGroup(rows.id)
      }).catch(() => {
      });
    },
    handleEdit(index, rows) {
      this.centerDialogVisible = true;
      this.isGroupEdit =true;

      this.groupInfo = {
        id: rows.id,
        aid: rows.aid,
        project: rows.project,
        projectkey: rows.projectkey,
        hardwaretype: rows.hardwaretype,
        description: rows.description,
        updateDate: rows.updateDate,
        updateby: JSON.parse(localStorage.getItem('account')).username,
        createby: rows.createby,
        data: rows.data
      }


    },
    updateGroup() {
      var _this = this;

      if (!_this.groupInfo.project || !_this.groupInfo.description || !_this.groupInfo.hardwaretype) {
        _this.$message.error("请填写相关必填信息");
        return;
      }

      var params = {
        id: _this.groupInfo.id,
        project: _this.groupInfo.project,
        projectkey: _this.groupInfo.projectkey,
        description: _this.groupInfo.description,
        hardwaretype: _this.groupInfo.hardwaretype  // Update hardwaretype if needed
      };

      var reqdata = {};
      var { urls } = _this.getresult(TMApipath.CONFIGMANAGE, TMApipath.URL_API_EDITCONFIGHARDWARE, reqdata);

      let loadingInstance = _this.$loading({ fullscreen: true, text: "Loading" });

      _this.axios.post(urls, params)
        .then((response) => {
          _this.$nextTick(() => { loadingInstance.close(); });
          if (response.status) {
            _this.centerDialogVisible = false;
            _this.getConfigHardwareTypeListByPage(_this.pageInfo.val, _this.pageInfo.size);
          } else {
            _this.$message.error(response.msg);
          }
        })
        .catch((error) => {
          _this.$nextTick(() => { loadingInstance.close(); });
          _this.$message.error("系统异常");
          console.error(error);
        });
    },
    addGroup() {
      var _this = this;
      if (_this.isGroupEdit) {
        _this.updateGroup(); // 如果处于编辑状态，调用更新方法
      } else {
        // 如果不是编辑状态，执行添加操作
        if (!_this.groupInfo.project || !_this.groupInfo.description || !_this.groupInfo.hardwaretype) {
          this.$message.error("请填写相关必填信息");
          return;
        }
        var params = {
          aid: _this.aid,
          project: _this.groupInfo.project,
          projectkey: _this.groupInfo.projectkey,
          description: _this.groupInfo.description,
          createby: _this.groupInfo.createby,
          updateby: _this.groupInfo.updateby,
          hardwaretype: _this.groupInfo.hardwaretype,
          data: _this.groupInfo.data
        }
        var reqdata = {}
        var { urls } = _this.getresult(TMApipath.CONFIGMANAGE, TMApipath.URL_API_ADDCONFIGHARDWARE, reqdata);
        console.log(urls)
        let loadingInstance = _this.$loading({ fullscreen: true, text: "Loading" });
        _this.axios.post(urls, params).then((response) => {
          _this.$nextTick(() => { loadingInstance.close(); });
          if (response.status) {
            _this.centerDialogVisible = false;
            // vuex记录
            _this.getConfigHardwareTypeListByPage(_this.pageInfo.val, _this.pageInfo.size);
          } else {
            _this.$message.error(response.msg);
          }
        }, (response) => {
          _this.$nextTick(() => { loadingInstance.close(); });
          _this.$message.error("系统异常");
          console.log(response)
        });
      }
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      // console.log(`当前页: ${val}`);
      var _this = this
      _this.pageInfo.val = val
      _this.getConfigHardwareTypeListByPage(_this.pageInfo.val, _this.pageInfo.size);
    },
    RightAddClick() {
      this.centerDialogVisible = true;
      this.isGroupEdit = false;

      this.groupInfo = {
        id: null,
        project: "",
        projectkey:'',
        hardwaretype: "",
        description: "",
        createby: JSON.parse(localStorage.getItem('account')).username, // 获取当前用户的用户名并赋值给 createby
        updateby: JSON.parse(localStorage.getItem('account')).username,
      }

    },
    addDevice() {
      var _this = this
      var params = {
        project: "",
        description: '',
        createby: "",
        hardwaretype: "",
      }
      var reqdata = {}
      var { urls } = _this.getresult(TMApipath.CONFIGMANAGE, TMApipath.URL_API_CREATEDEVICE, reqdata);

      let loadingInstance = _this.$loading({ fullscreen: true, text: "Loading" });

      _this.axios.post(urls, params).then((response) => {
        _this.$nextTick(() => { loadingInstance.close(); });
        if (response.status) {
          _this.centerDialogVisible = false;
          // 演示2S拉取
          setTimeout(_this.getTotleDevice(), 2000);
        } else {
          this.$message.error(response.msg);
        }
      }, (response) => {
        _this.$nextTick(() => { loadingInstance.close(); });
        console.log(response)
      });
    },
    deleteGroup(id) {
      var _this = this
      var params = {
        id: id
      }
      var reqdata = {}
      var { urls } = _this.getresult(TMApipath.CONFIGMANAGE, TMApipath.URL_API_DELETECONFIGHARDWARE, reqdata);
      let loadingInstance = _this.$loading({ fullscreen: true, text: "Loading" });
      _this.axios.post(urls, params).then((response) => {
        _this.$nextTick(() => { loadingInstance.close(); });
        if (response.status) {
          _this.centerDialogVisible = false;
          // vuex记录
          _this.getConfigHardwareTypeListByPage(_this.pageInfo.val, _this.pageInfo.size);

        } else {
          this.$message.error(response.msg);
        }
      }, (response) => {
        _this.$nextTick(() => { loadingInstance.close(); });
        console.log(response)
      });
    }
  },


}

</script>

<style scoped>
.groups {
  overflow: hidden
}


.rightButton {
  width: 30px
}

.container_right {
  margin: 5px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.el-dialog_header {
  padding: 0px
}
</style>